
import React from 'react';
import PageHeader from '../common/PageHeader';

const CampaignHeader = () => {
  return (
    <PageHeader 
      pageTitle="Campaigns" 
      mainTitle="Marketing Campaigns"
      description="Create and manage targeted marketing campaigns"
    />
  );
};

export default CampaignHeader;
